export function getBedShareInfo (data) {
  if (!data) return null

  return {
    hideNumOfBedShare: data.bedShareMaxOccupancy <= 0 || data.bedShareAlertType === 'ChildIncludeBedShare',
    showExtraChildLabel: data.bedShareAlertType === 'Okinawa'
  }
}
